<template>
  <div class="search">
    <!-- 面包屑 -->
    <div class="position container yu_fc"><router-link to="/">首页</router-link><i v-if="key != ''"></i><template v-if="key != ''">{{key}}</template></div>
    <!-- 面包屑 -->
    <div class="boxs">
      <!-- 排序 -->
      <div class="class_sort">
        <div class="left">排序：</div>
        <div class="right">
          <span><a href="javascript:void(0)" class="active" @click="onHot(1)">默认</a></span>
          <span><a href="javascript:void(0)" :class="price == 5 ? 'desc' : 'ascn'" @click="onHot(0)">价格<i></i></a></span>
        </div>
      </div>
      <!-- 排序 -->
      <!-- 数据 -->
      <ul class="item_list">
        <li class="no_data" v-if="searchArr.length == 0">您要的“{{key}}”还未上架</li>
        <li v-for="(item, index) in searchArr" :key="index">
          <a href="javascript:void(0)" class="img" @click="onGoodsDetail(item.id,item.defaultSkuId,item.name)"><img :src="item.pic" /></a>
          <div class="label">
            <span>抄底特惠</span>
            <span>抄底特惠</span>
            <span>抄底特惠</span>
          </div>
          <a href="javascript:void(0)" class="title" @click="onGoodsDetail(item.id,item.defaultSkuId,item.name)">{{item.name}}</a>
          <div class="price">
            <span>￥{{item.price}}</span>
            <del>￥{{item.originalPrice}}</del>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { productList } from "@/api/product";
export default {
  name: "search",
  data() {
    return {
      key: "", // 关键词
      searchArr: [], // 搜索数据
      price: 0, // 价格排序
      order: 1, // 分类排序
    }
  },
  created() {
    this.key = this.$route.query.key
    console.log(this.order)
    this.getSearch(this.key,this.order)
  },
  methods: {
    async getSearch(key,order) {
      const res = await productList({
        keyword: key,
        pageSize: 500,
        pageNum: 1,
        order: order
      })
      console.log(res);
      if (res.code == 200) {
        this.searchArr = res.data.list;
      }
    },
    // 默认/价格
    onHot(num){
      let nums = 0
      if(this.price == 0 || this.price == 4){
        nums = 5
      }else if(this.price == 5){
        nums = 4
      }
      switch (nums) {
        case 4:
          this.order = 4
          this.price = 4
          break;
        case 5:
          this.order = 5
          this.price = 5
          break;
        default:
          this.order = num
          break;
      }
      this.getSearch(this.key, this.order)
    },
    // 商品详情
    onGoodsDetail(id, skuId, name){
      this.$router.push({
        path: "/goodsDetail",
        query: {
          id: id,
          skuId: skuId
        }
      })
    }
  },
  watch:{
    $route(to,from){
      console.log(to,from)
      this.key = this.$route.query.key
      this.getSearch(this.key, this.order)
    }
  },
  mounted(){
    $(".class_sort").on("click", "a", function() {
      $(".class_sort a").removeClass("active")
      $(this).addClass("active")
    })
  }
};
</script>

<style scoped>
.search{
  padding-bottom: 60px;
  background: #f2f2f2;
}
.boxs{
  width: 1200px;
  padding: 13px 40px 0;
  margin: 0 auto;
  overflow: hidden;
  background: #fff;
}
/* 分类/排序 */
.class_sort{
  width: 100%;
  padding: 20px 0 6px;
  border-bottom: solid 1px #dadada;
  overflow: hidden;
}
.class_sort .left{
  float: left;
  width: 78px;
  color: #999;
  font-size: 16px;
}
.class_sort .right{
  float: left;
  width: 1042px;
}
.class_sort .right span{
  float: left;
}
.class_sort .right span a{
  float: left;
  color: #333;
  font-size: 16px;
  margin: 0 32px 16px 0;
}
.class_sort .right span a.active,
.class_sort .right span a:hover{
  color: #C6B798;
}
.class_sort .right span a i{
  float: right;
  width: 11px;
  height: 14px;
  margin-left: 6px;
  position: relative;
}
.class_sort .right span a i::before,
.class_sort .right span a i::after{
  content: "";
  width: 11px;
  height: 6px;
  overflow: hidden;
  background-image: url("../assets/images/icon_0.png");
  background-repeat: no-repeat;
  position: absolute;
  left: 0;
}
.class_sort .right span a i::before{
  top: 0;
  background-position: -11px -141px;
}
.class_sort .right span a i::after{
  bottom: 0;
  background-position: -11px -147px;
}
.class_sort .right span a.active.ascn i::before{
  background-position: 0px -141px;
}
.class_sort .right span a.active.desc i::after{
  background-position: 0px -147px;
}
/* 数据 */
.item_list{
  width: 1133px;
  min-height: 150px;
  padding-top: 20px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.item_list li{
  width: 270px;
  text-align: center;
  padding-bottom: 10px;
  margin-right: 13px;
  margin-bottom: 10px;
  overflow: hidden;
}
.item_list li:hover{
  background:rgba(244,240,234,1);
  box-shadow:0px 3px 10px 0px rgba(0, 0, 0, 0.1);
}
.item_list li.no_data{
  width: 100%;
  color: #333;
  font-size: 20px;
  font-weight: bold;
  line-height: 110px;
  padding: 0;
  margin: 0;
}
.item_list li.no_data:hover{
  background: #fff;
  box-shadow:0 0 0 0px rgba(0, 0, 0, 0);
}
.item_list li .img,
.item_list li .img img{
  float: left;
  width: 270px;
  height: 270px;
}
.item_list li .label{
  float: left;
  width: 100%;
  font-size: 0;
  padding: 8px 0;
}
.item_list li .label span{
  color: #fff;
  height: 22px;
  line-height: 20px;
  padding: 0 3px;
  margin: 0 3px;
  background: #E36844;
  display: inline-block;
  vertical-align: top;
}
.item_list li .title{
  display: inline-block;
  color: #333;
  max-width: 100%;
  padding: 0 10px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item_list li .title:hover{
  color: #B2A181;
}
.item_list li .price{
  font-size: 0;
  padding-top: 14px;
}
.item_list li .price span,
.item_list li .price del{
  display: inline-block;
  vertical-align: top;
}
.item_list li .price span{
  color: #DA2833;
  padding-right: 6px
}
.item_list li .price del{
  color: #999;
}
</style>